import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';

export default [
    {
        path: '/intra_city/list',
        name: ROUTE_NAME.INTRA_CITY_LIST,
        meta: {
            title: '同城活动',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => ({
            component: import(/* webpackChunkName: "market" */ '@/pages/intraCity/list.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/intra_city/create',
        name: ROUTE_NAME.INTRA_CITY_CREATE,
        meta: {
            title: '创建活动',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => ({
            component: import(/* webpackChunkName: "market" */ '@/pages/intraCity/create.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/intra_city/create_result',
        name: ROUTE_NAME.INTRA_CITY_CREATE_RESULT,
        meta: {
            title: '创建结果',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => ({
            component: import(/* webpackChunkName: "market" */ '@/pages/intraCity/createResult.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/intra_city/detail/:activityId',
        name: ROUTE_NAME.INTRA_CITY_DETAIL,
        meta: {
            title: '活动详情',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => ({
            component: import(/* webpackChunkName: "market" */ '@/pages/intraCity/detail.vue'),
            loading: Loading,
        }),
    },
];
